import React, {useCallback, useEffect, useRef} from 'react';
import {SteppedEase, TweenMax} from "gsap";

const MouseAround = (props) => {

    const mouse = useRef();

    useEffect(()=>{

        setTimeout(()=>{

            if(mouse.current){
                TweenMax.to(mouse.current,2,{
                    backgroundPosition: `0 -4860px`,ease:SteppedEase.config(81),
                    repeat:-1,
                    repeatDelay: 1
                });

            }
            
        }, 0);

    }, [])

    const getStyle = useCallback(()=>{

        return {
            backgroundImage: `url(https://msobd-storage.azureedge.net/images/gallery/mouse_around.png)`,
            width: '60px',
            height: '60px'
        };
    }, [])


    return (
        <div ref={mouse} style={getStyle()}/>
    )
};

export default MouseAround
